module.exports = __webpack_public_path__ + "static/media/android.c0438c27.png";